export default "__VITE_PUBLIC_ASSET__5a18759f__"